import React from "react";
import { Box } from "@chakra-ui/react";

// Colors from the original gradient
const COLORS = {
  lightPurple: "#EAE7FE",
  brightPurple: "#B5C3FF",
  lightOrange: "#FFEFD0",
  brightOrange: "#FFC480",
  peach: "#FFD4E0",
  peachDark: "#FFC8D8",
  greenLight: "#B2F9D4",
  greenDark: "#8FEDC9",
  lightCyan: "#A3EEFF",
  brightCyan: "#00B7FF",
};

// Radial background gradient
const BACKGROUND_GRADIENT = "radial-gradient(circle at center, #EAE7FE 0%, #93e0ff 60%, #EAE7FE 100%)";

// Blob configurations using accent colors: green, orange, peach, purple, cyan
const BLOBS = [
  {
    size: "650px",
    top: "-10%",
    left: "-10%",
    bottom: undefined,
    right: undefined,
    gradient: `radial-gradient(circle at center, ${COLORS.greenDark} 0%, ${COLORS.greenLight} 100%)`,
    animation: "blob-motion-1 6s infinite",
  },
  {
    size: "680px",
    top: "50%",
    left: "25%",
    bottom: undefined,
    right: undefined,
    gradient: `radial-gradient(circle at center, ${COLORS.brightOrange} 0%, ${COLORS.lightOrange} 100%)`,
    animation: "blob-motion-2 8s infinite",
  },
  {
    size: "600px",
    top: "0%",
    left: "50%",
    bottom: undefined,
    right: undefined,
    gradient: `radial-gradient(circle at center, ${COLORS.peachDark} 0%, ${COLORS.peach} 100%)`,
    animation: "blob-motion-3 6s infinite",
  },
  {
    size: "680px",
    top: "15%",
    left: undefined,
    bottom: undefined,
    right: "0%",
    gradient: `radial-gradient(circle at center, ${COLORS.brightPurple} 0%, ${COLORS.lightPurple} 100%)`,
    animation: "blob-motion-4 12s infinite",
  },
  {
    size: "700px",
    top: "5%",
    left: undefined,
    bottom: undefined,
    right: "5%",
    gradient: `radial-gradient(circle at center, ${COLORS.brightCyan} 0%, ${COLORS.lightCyan} 100%)`,
    animation: "blob-motion-5 10s infinite",
  },
];

export function AgentsColoredBlobBackground() {
  return (
    <>
      <style>
        {`
          @keyframes blob-motion-1 {
            0%, 100% { transform: translate(0, 0) scale(1); }
            50% { transform: translate(25vw, 35vh) scale(1.2); }
          }

          @keyframes blob-motion-2 {
            0%, 100% { transform: translate(0, 0) scale(1); }
            50% { transform: translate(30vw, -20vh) scale(1.3); }
          }

          @keyframes blob-motion-3 {
            0%, 100% { transform: translate(0, 0) scale(1); }
            50% { transform: translate(-20vw, 40vh) scale(0.85); }
          }

          @keyframes blob-motion-4 {
            0%, 100% { transform: translate(0, 0) scale(1); }
            50% { transform: translate(-30vw, -20vh) scale(1.2); }
          }

          @keyframes blob-motion-5 {
            0%, 100% { transform: translate(0, 0) scale(1); }
            50% { transform: translate(-40vw, 60vh) scale(1.1); }
          }

          .animated-gradient-blob {
            position: absolute;
            border-radius: 50%;
            opacity: 0.8;
            filter: blur(80px);
            animation-timing-function: ease-in-out;
            animation-iteration-count: infinite;
          }
        `}
      </style>
      <Box
        aria-hidden="true"
        pos="absolute"
        top={0}
        left={0}
        w="100%"
        h="800px"
        zIndex={0}
        overflow="hidden"
        background={BACKGROUND_GRADIENT}
      >
        {BLOBS.map((blob) => (
          <Box
            key={blob.animation}
            className="animated-gradient-blob"
            w={blob.size}
            h={blob.size}
            background={blob.gradient}
            top={blob.top}
            left={blob.left}
            bottom={blob.bottom}
            right={blob.right}
            sx={{ animation: blob.animation }}
          />
        ))}
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          background="linear-gradient(to top, white 0%, transparent)"
          pointerEvents="none"
        />
      </Box>
    </>
  );
}
